export default __webpack_public_path__ + "static/media/milling.26d57451.jpg";